import { Component } from 'react'
import { ResourceType } from '@ds-frontend/resource'
import { autobind } from 'core-decorators'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import router from 'next/router'
import PropTypes from 'prop-types'

import HeaderQuoteView from './HeaderQuoteView'
import { mockQuoteHeader } from './mock'
import { addFixedToBody, moveBackAfterClose } from 'common/utils/modalScroll'


const propTypes = {
  uuid: PropTypes.string.isRequired,
  option: PropTypes.string,
  optionData: PropTypes.object,
  quoteList: ResourceType.isRequired,
  quotePrint: ResourceType.isRequired,
  options: PropTypes.array.isRequired,
  router: PropTypes.object.isRequired,
}

const defaultProps = {
  option: undefined,
  optionData: {},
}

export default class HeaderQuoteContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isActive: false,
    }
  }

  @autobind
  setActive() {
    this.setState({ isActive: !this.state.isActive }, _ => {
      if(this.state.isActive) {
        addFixedToBody()
      } else {
        moveBackAfterClose()
      }
    })
  }

  @autobind
  handleChangeLanguage(lang) {
    const language = lang === 'de' ? '' : `/${lang}`
    location.href = `${language}${router.asPath}`
  }

  componentDidMount() {
    if(isEmpty(this.props.quotePrint.data)) {
      this.props.quotePrint.customRequest({ options: this.props.options, quote: this.props.router.query.id })
    }
  }

  componentWillUnmount() {
    moveBackAfterClose()
  }

  render() {
    const quote = get(this.props.quoteList, 'data', {})
    if(isEmpty(quote)) {
      return null
    }
    return (
      <HeaderQuoteView
        {...this.props}
        quote={quote}
        optionId={this.props.router.query.option}
        optionData={this.props.optionData}
        headerData={mockQuoteHeader}
        isActive={this.state.isActive}
        setActive={this.setActive}
        handleChangeLanguage={this.handleChangeLanguage}
      />
    )
  }
}

HeaderQuoteContainer.propTypes = propTypes
HeaderQuoteContainer.defaultProps = defaultProps
